export default __webpack_public_path__ + "static/media/icons8-javascript.1776ef3b.gif";